module.exports = __webpack_public_path__ + "media/images/features/draft/text-mv-15a4709edd496fa2ff5fa52eab5f5a81.svg";